import React from 'react';
import { useGlobalState } from '../stateProvider/StateProvider';
import Page from '../layout/Page';
import styled from 'styled-components';
import { buildGetQuery } from '../utility/functions';

const Sikes = styled.div`
    background-image: url(https://media.tenor.com/FJiASlrWtY8AAAAd/tyler-the-creator-sike.gif);
    background-repeat: no-repeat;
    background-position: center center;
    background-size: contain;

    height: calc(100svh - 13em);
    width: 100%;
`;

export const Sike = ({ }) => <Sikes />

const Feedback = ({ ...props }) => {
    const {
        state: {
            active_user,
        },
        
    } = useGlobalState();

    const { firstName, lastName, email, companyName, hsAccountId, macolaId, userId } = active_user;

    return (
        <Page>
            <iframe
                src={buildGetQuery('https://form.jotform.com/230815966410153', {
                    'name[first]': firstName,
                    'name[last]': lastName,
                    contactEmail: email,
                    companyName,
                    hsAccountId,
                    macolaId,
                    userId
                })}
                title='Feedback Form'
                style={{ width: '100%', height: '100svh', border: 'unset' }}
            />
        </Page>
    );
}

export default Feedback;
